import { normalizeThirdPartyListRow } from "../third_party/normalizeThirdPartyListRow";

/**
 * direct_list / 分组未分组等接口返回的「直连账户」行数据归一化。
 *
 * 接口字段风格不统一（brokerName、market/visible 多种布尔写法等），
 * 本模块把单条 raw 转成列表/弹窗可直接绑定的行对象。
 *
 * 注意：
 * - 仅按 userType === 5 区分第三方，其余一律走 CTP 直连分支（会写死 userType: 4）。
 * - 杰宜斯类账户（userType 1/2/3）若误走本入口，类型会被标成 4；分组页应用
 *   groupingAccountType.js 在 normalize 之前用原始 userType 展示文案。
 */

/**
 * 直连列表行统一入口：按 userType 分发到 CTP 或第三方归一化。
 *
 * @param {Record<string, unknown>} raw 接口单条记录
 * @returns {Record<string, unknown>} 表格行（含 brokerName、userTypeName、market、visible 等）
 */
export function normalizeDirectListRow(raw) {
  const ut = Number(raw.userType);
  if (ut === 5) {
    return normalizeThirdPartyListRow(raw);
  }
  return normalizeCtpDirectListRow(raw);
}

/**
 * CTP 直连账户（userType 4）行归一化。
 *
 * 处理内容：
 * - brokerName / serverManageName：来自 raw.brokerName，空则 ""
 * - ServerManageId：来自 raw.brokerId
 * - userType / userTypeName：固定为 4、「CTP直连」
 * - market：兼容 market、isMarket 的 1/true/"1"
 * - visible：非 false/0/"0" 视为可见
 * - sort：缺省为 0
 *
 * @param {Record<string, unknown>} raw
 * @returns {Record<string, unknown>}
 */
export function normalizeCtpDirectListRow(raw) {
  const brokerName =
    raw.brokerName != null && raw.brokerName !== ""
      ? String(raw.brokerName)
      : "";
  const smId =
    raw.brokerId != null && raw.brokerId !== ""
      ? String(raw.brokerId)
      : "";
  const marketOn =
    raw.market === true ||
    raw.market === 1 ||
    String(raw.market) === "1" ||
    raw.isMarket === true ||
    raw.isMarket === 1 ||
    String(raw.isMarket) === "1";
  const visibleRaw = raw.visible;
  const visibleOn = !(
    visibleRaw === false ||
    visibleRaw === 0 ||
    String(visibleRaw) === "0"
  );
  return {
    ...raw,
    brokerName,
    serverManageName: brokerName,
    ServerManageId: smId,
    userType: 4,
    userTypeName: "CTP直连",
    market: marketOn,
    visible: visibleOn,
    sort: raw.sort != null ? raw.sort : 0,
  };
}



// WEBPACK FOOTER //
// ./src/view/user/eval_jees/ctp_direct/normalizeDirectListRow.js